<div class="dash-page">
  <span class="chip chip-info dash-page__badge">
    <i class="bi bi-flask"></i>
    VIVE Labs
  </span>

  @if (selectedDashboard) {
    <header class="dash-page__head">
      <a class="dash-page__back" [routerLink]="['/admin', 'dashboards']">
        <i class="bi bi-arrow-left"></i>
        Back to dashboards
      </a>
      <div class="dash-page__title">
        <h2 class="mb-0">{{ selectedDashboard.name }}</h2>
        @if (selectedDashboard.description) {
          <p class="dash-page__sub mb-0">
            {{ selectedDashboard.description }}
          </p>
        }
      </div>
      <div class="action-row justify-end dash-page__actions">
        <a
          class="btn btn-outline btn-sm"
          [href]="selectedDashboard.embedUrl"
          target="_blank"
          rel="noopener noreferrer"
        >
          <i class="bi bi-box-arrow-up-right me-1"></i>
          Open in new tab
        </a>
        <button
          type="button"
          class="btn btn-primary btn-sm"
          (click)="openFullscreen(selectedDashboard)"
        >
          <i class="bi bi-arrows-fullscreen me-1"></i>
          Full screen
        </button>
      </div>
    </header>

    <iframe
      [src]="selectedDashboard.src"
      title="VIVE Labs dashboard"
      class="dash-frame"
    ></iframe>
  } @else if (currentDashboardSlug) {
    <div class="dash-page__empty">
      <h2 class="mb-0">Dashboard not found</h2>
      <p class="mb-0">The dashboard you requested does not exist.</p>
      <a class="btn btn-primary btn-sm" [routerLink]="['/admin', 'dashboards']">
        Back to dashboards
      </a>
    </div>
  } @else {
    <header class="dash-page__head dash-page__head--index">
      <div class="dash-page__title">
        <h2 class="mb-0">Dashboard library</h2>
        <p class="dash-page__sub mb-0">
          Each dashboard opens on its own page for a cleaner view.
        </p>
      </div>
    </header>

    <div class="dash-page__grid">
      @for (dashboard of dashboards; track dashboard.slug) {
        <article
          class="dash-card"
          role="link"
          tabindex="0"
          (click)="openDashboardPage(dashboard)"
          (keydown.enter)="openDashboardPage(dashboard)"
        >
          <div class="dash-card__body">
            <h3 class="dash-card__name">{{ dashboard.name }}</h3>
            @if (dashboard.description) {
              <p class="dash-card__sub mb-0">{{ dashboard.description }}</p>
            }
          </div>

          <div class="dash-card__footer">
            <span class="dash-card__cta">
              Open dashboard
              <i class="bi bi-arrow-right"></i>
            </span>
            <div class="dash-card__actions">
              <a
                class="btn btn-outline btn-sm"
                [href]="dashboard.embedUrl"
                target="_blank"
                rel="noopener noreferrer"
                (click)="stopCardAction($event)"
              >
                <i class="bi bi-box-arrow-up-right me-1"></i>
                New tab
              </a>
              <button
                type="button"
                class="btn btn-primary btn-sm"
                (click)="stopCardAction($event); openFullscreen(dashboard)"
              >
                <i class="bi bi-arrows-fullscreen me-1"></i>
                Full screen
              </button>
            </div>
          </div>
        </article>
      }
    </div>
  }

  @if (fullscreenDashboard) {
    <div class="dash-fullscreen-overlay" (click)="closeFullscreen()">
      <div class="dash-fullscreen-sheet" (click)="$event.stopPropagation()">
        <button
          type="button"
          class="dash-fullscreen-close"
          (click)="closeFullscreen()"
          aria-label="Close full screen dashboard"
        >
          <i class="bi bi-x-lg"></i>
        </button>
        <iframe
          [src]="fullscreenDashboard.src"
          title="VIVE Labs dashboard full screen view"
          class="dash-frame dash-frame--fullscreen"
        ></iframe>
      </div>
    </div>
  }
</div>
